// src/funnels/experiments/web_unify_upsell_second_screen.ts
import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// Group A — bundle-essential → inject full skip chain
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_unify_upsell_second_screen~1
		female: {
			upsell: {
				experiment: {
					'upsell-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_unify_upsell_second_screen'
						),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_unify_upsell_second_screen~1
		'female-water-fasting': {
			upsell: {
				experiment: {
					'upsell-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_unify_upsell_second_screen'
						),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_unify_upsell_second_screen~1
		male: {
			upsell: {
				experiment: {
					'upsell-m': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_unify_upsell_second_screen'
						),
				},
			},
		},

		// Group B — bundle-activity → ensure white X visible
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_unify_upsell_second_screen~1
		'activity-female-walking': {
			upsell: {
				experiment: {
					'upsell-activity-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_unify_upsell_second_screen__white_x'
						),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_unify_upsell_second_screen~1
		'activity-female-tai-chi-walking-v2-al': {
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_unify_upsell_second_screen__white_x'
						),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_unify_upsell_second_screen~1
		'activity-female-tai-chi-walking-v2': {
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_unify_upsell_second_screen__white_x'
						),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_unify_upsell_second_screen~1
		'activity-female-tai-chi-walking-pr': {
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_unify_upsell_second_screen__white_x'
						),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_unify_upsell_second_screen~1
		// NOTE: activity-male-tai-chi-walking is a truncated funnel that redirects to
		// activity-male-walking via redirectTo.always — by the time the user reaches
		// the upsell, appAreaConfig.appArea is already 'activity-male-walking'.
		'activity-male-walking': {
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_unify_upsell_second_screen__white_x'
						),
				},
			},
		},
	},
]

export default config
